import { Controller, useForm } from "react-hook-form";
import Field from "src/components/field";
import FileDropZone from "src/components/FileDropZone";
import { Button } from "src/components/ui/button";
// import { Input } from "src/components/ui/input";
import { Provider } from "src/components/ui/provider";
// import { Textarea } from "src/components/ui/Textarea";
import { createListCollection, Dialog, Portal, Select } from "@chakra-ui/react";

type InputType = { type: string; pdf: File | undefined };

export default function UploadContractModal({
  availableTypes,
  open,
  onSuccess,
  closeModal,
}: {
  availableTypes: string[];
  open: boolean;
  closeModal: () => void;
  onSuccess: (data: { type: string; file: File }) => void;
}) {
  const { control, handleSubmit, setError } = useForm<InputType>();

  const onSubmit = (data: InputType) => {
    const { type, pdf } = data;

    if (!pdf) {
      setError("pdf", { message: "upload contract" });
    }
    onSuccess({ type, file: pdf! });
    closeModal();
  };

  return (
    <Provider>
      <Dialog.Root
        open={open}
        onOpenChange={({ open }) => !open && closeModal()}
        placement="center"
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner p={4}>
            <Dialog.Content onSubmit={handleSubmit(onSubmit)} as={"form"}>
              <Dialog.Header>
                <Dialog.Title fontWeight={"semibold"} fontSize={"lg"}>
                  Upload Contract Document
                </Dialog.Title>
              </Dialog.Header>
              <Dialog.Body color="fg" spaceY={4}>
                {/* <form onSubmit={handleSubmit(onSubmit)} className="p-4 space-y-4"> */}

                <Controller
                  control={control}
                  name="type"
                  rules={{ required: "Select document type" }}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => {
                    return (
                      <Field
                        label="Document Type"
                        errorText={error?.message?.toString()}
                      >
                        <Select.Root
                          collection={documentOptions}
                          value={[value]}
                          onValueChange={({ value }) => onChange(value[0])}
                          borderWidth={"thin"}
                          rounded="md"
                        >
                          <Select.HiddenSelect />
                          <Select.Control>
                            <Select.Trigger>
                              <Select.ValueText
                                px={2}
                                _placeholder={{ color: "fg.muted" }}
                                placeholder="Select document type"
                              />
                            </Select.Trigger>
                            <Select.IndicatorGroup>
                              <Select.Indicator />
                            </Select.IndicatorGroup>
                          </Select.Control>
                          <Select.Positioner>
                            <Select.Content>
                              {documentOptions.items
                                .filter(
                                  (item) => !availableTypes.includes(item.value)
                                )
                                .map((option) => (
                                  <Select.Item item={option} key={option.value}>
                                    {option.label}
                                    <Select.ItemIndicator />
                                  </Select.Item>
                                ))}
                            </Select.Content>
                          </Select.Positioner>
                        </Select.Root>
                      </Field>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="pdf"
                  rules={{ required: "Upload your contract pdf" }}
                  render={({
                    field: { name, value, onChange },
                    fieldState: { error },
                  }) => {
                    return (
                      <Field errorText={error?.message}>
                        <FileDropZone
                          inputId={"file-upload"}
                          values={value ? [value] : []}
                          onChange={(files, error) => {
                            if (!error) {
                              onChange(files[0]);
                              setError(name, {
                                message: undefined,
                                type: undefined,
                              });
                              return;
                            }
                            setError(name, { message: error, type: "" });
                          }}
                          limit={1}
                          label={!value ? "Upload File" : "Replace File"}
                          accept={".pdf"}
                        />
                      </Field>
                    );
                  }}
                />
                {/* </form> */}
              </Dialog.Body>
              <Dialog.Footer>
                <Dialog.ActionTrigger asChild color="fg">
                  <Button variant="outline">Cancel</Button>
                </Dialog.ActionTrigger>
                <Button type="submit">Save</Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Provider>
  );
}

const documentOptions = createListCollection({
  items: [
    { label: "Non-Disclosure Agreement (NDA)", value: "NDA" },
    {
      label: "Intellectual Property (IP) Ownership & Assignment Agreement",
      value: "IPO-AA",
    },
    { label: "Termination and Dispute Resolution Agreement", value: "TDRA" },
    { label: "Service Level Agreement (SLA)", value: "SLA" },
  ],
});
